import { createContext, Dispatch, SetStateAction } from 'react';
import { Nullish } from '~/types/Nullish';
import { User } from '~/apis/ssf';

export type Policy =
  | 'create-lifter'
  | 'edit-lifter'
  | 'delete-lifter'
  | 'list-lifter-license'
  | 'create-lifter-license'
  | 'edit-lifter-license'
  | 'delete-lifter-license'
  | 'create-club'
  | 'edit-club'
  | 'delete-club'
  | 'create-competition'
  | 'edit-competition'
  | 'delete-competition'
  | 'list-competition-registration'
  | 'create-competition-registration'
  | 'edit-competition-registration'
  | 'delete-competition-registration'
  | 'manual-approve-registration'
  | 'manage-competition-result'
  | 'see-competition-registration-status'
  | 'create-district'
  | 'edit-district'
  | 'delete-district'
  | 'create-referee'
  | 'edit-referee'
  | 'delete-referee'
  | 'list-referee-license'
  | 'create-referee-license'
  | 'edit-referee-license'
  | 'delete-referee-license'
  | 'manage-users'
  | 'list-club-admin'
  | 'create-club-admin'
  | 'delete-club-admin'
  | 'list-district-admin'
  | 'delete-district-admin'
  | 'create-district-admin'
  | 'manage-series'
  | 'create-division'
  | 'edit-division'
  | 'delete-division'
  | 'manage-round'
  | 'manage-team'
  | 'manage-round-result'
  | 'export-competition-registrations'
  | 'see-competition-api-key'
  | 'manage-competition-integrations'
  | 'manage-records'
  | 'manage-standard-records'
  | 'list-referee-admin'
  | 'manage-competition-division'
  | 'manage-competition-team';

interface AuthenticationContextType {
  login: (username: string, password: string) => Promise<void>;
  can: (policy: Policy, entityId?: number, checkAnyClubAdmin?: boolean) => boolean;
  setUser: Dispatch<SetStateAction<Nullish<User>>>;
  logout: () => Promise<void>;
  isAuthenticated: boolean;
  token: Nullish<string>;
  isSuperUser: boolean;
  user: Nullish<User>;
}

export const AuthenticationContext = createContext<AuthenticationContextType>({
  setUser: () => {
    throw new Error('Function not implemented.');
  },
  login: () => {
    throw new Error('Function not implemented.');
  },
  logout: () => {
    throw new Error('Function not implemented.');
  },
  can: () => {
    throw new Error('Function not implemented.');
  },
  isAuthenticated: false,
  isSuperUser: false,
  token: undefined,
  user: undefined,
});
